import * as Sentry from '@sentry/react'

// @link https://docs.sentry.io/platforms/javascript/guides/react/
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  environment: process.env.REACT_APP_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sentry.browserProfilingIntegration(),
    // Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
  ],
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  tracePropagationTargets: ['localhost', process.env.REACT_APP_API_URL],
  profilesSampleRate: process.env.REACT_APP_SENTRY_PROFILES_SAMPLE_RATE,
  replaysSessionSampleRate:
    process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate:
    process.env.REACT_APP_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
  enableLogs: true,
  beforeSend(event, hint) {
    const error = hint?.originalException

    const status = error?.response?.status || error?.status || error?.code

    if (status === 401) {
      return null
    }

    return event
  },
})
